import { Point } from "highcharts";
import { grey } from "@mui/material/colors";
import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";
import { money } from "@/utils/numeral/money";

export const getResourceDetailsCoverageChartTooltipValueFormatter = (
  chartData?: HighchartsChartDataType | null,
) => {
  return (point: Point) => {
    const category = point.category;
    const index = point.index;

    const sp = chartData?.series.at(0);
    const ri = chartData?.series.at(1);
    const onDemand = chartData?.series.at(2);

    const spPercentAtIndex = sp?.data?.at(index);
    const riPercentAtIndex = ri?.data?.at(index);
    const onDemandPercentAtIndex = onDemand?.data?.at(index);

    const spPercent = spPercentAtIndex?.rawValue?.percentage ?? 0;
    const riPercent = riPercentAtIndex?.rawValue?.percentage ?? 0;
    const onDemandPercent = onDemandPercentAtIndex?.rawValue?.percentage ?? 0;

    const spCost = spPercentAtIndex?.rawValue?.amount ?? 0;
    const riCost = riPercentAtIndex?.rawValue?.amount ?? 0;
    const onDemandCost = onDemandPercentAtIndex?.rawValue?.amount ?? 0;

    const totalPercent = spPercent + riPercent;
    const totalCost = spCost + riCost;

    return `
    <div style="font-size: 13px; color: #666; margin-bottom: 8px;">${category}</div>  
      <div style="display: flex; flex-direction: column; gap: 8px;">
        ${getRow("SP Coverage", spCost, spPercent, sp?.color)}
        
        ${getRow("RI Coverage", riCost, riPercent, ri?.color)}
        
        ${getRow("On-Demand", onDemandCost, onDemandPercent, onDemand?.color)}
      </div>
      
      <div style="padding-top: 6px;display: flex;justify-content: space-between;font-weight: 500;font-size: 13px;">
            <span>Coverage</span>
            
            <div style="display: flex;">
              <b>${totalPercent.toFixed(2)}%</b>
              <b>(${money(totalCost)})</b>
            </div>
      </div>
      `;
  };
};

const getRow = (
  name: string,
  value: number,
  percent: number,
  color?: string,
) => {
  return `
     <div style="display: flex; justify-content: space-between; align-items: center; color: ${grey[600]};">
        <span style="display: flex; align-items: center; font-size: 11px; margin-right: 16px;">
            <span style="font-weight: 500; font-size: 13px;border-radius: 2px;  padding-left: 8px; border-left: 3px solid ${color}">
                ${name}
            </span>
        </span>

        <span style="font-weight: bold; font-size: 13px; "> ${percent.toFixed(2)}% (${money(value)})</span>
     </div>
  
  `;
};
